import { render, staticRenderFns } from "./VChevronRight.vue?vue&type=template&id=93b7701a&"
import script from "./VChevronRight.vue?vue&type=script&lang=js&"
export * from "./VChevronRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports